import { useAtParentIndex, useParent } from '../utils/components';
import { INDEX_BAR_BIND_INDEX_ANCHOR_KEY, INDEX_BAR_COUNT_INDEX_ANCHOR_KEY } from '../index-bar/provide';
export function useIndexBar() {
  var {
    parentProvider,
    bindParent
  } = useParent(INDEX_BAR_BIND_INDEX_ANCHOR_KEY);
  var {
    index
  } = useAtParentIndex(INDEX_BAR_COUNT_INDEX_ANCHOR_KEY);

  if (!parentProvider || !bindParent) {
    throw Error('[Varlet] IndexAnchor: You should use this component in "IndexBar"');
  }

  return {
    index,
    indexBar: parentProvider,
    bindIndexBar: bindParent
  };
}